/* This example requires Tailwind CSS v2.0+ */
import React, { useState } from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { formatContentfulComponentProps } from '../../../../../../../utils/globals';
import { IBlock, IColor } from '../../../../../../../utils/types/contentful';
import { SubCollectionHighlight } from '../../../../../Cards/Collection/SubHighlight/subCollectionHightlight';
import { Link } from '../../../../../Elements/Link';
import { List } from '../../../../../Navigation/List/list';
import FilterService from '../../../../../../../services/FilterService';

export interface DesktopNavigationDetailsProps {
  details: IBlock;
  color: IColor;
}

const returnNavigationItem = (itemsLength) => {
  switch (itemsLength) {
    case 3:
      return 'w-1/3 xl:w-1/4';
    default:
      return `w-1/${itemsLength.length + 1}`;
  }
};

export const DesktopNavigationDetails = ({
  details,
  color,
}: DesktopNavigationDetailsProps) => {
  const [currentDetail, setCurrentDetail] = useState(details.items[0].items[1]);
  const returnNavigationDetailsList = () =>
    details.items.map((detail: IBlock) => {
      const navigationDetailListItems = detail.items?.map((item) => {
        if (item.text) {
          return {
            children: (
              <div className='mb-4 text-2xl flex justify-start'>
                <Label
                  truncate
                  {...item}
                  color={{ classname: 'gray-800' }}
                  size='inherit'
                  weight='bold'
                />
              </div>
            ),
          };
        }

        const { link, image } = formatContentfulComponentProps(item);

        return {
          children: (
            <Link
              {...link}
              type='Page'>
              <div
                className='hover:translate-x-2 py-2 hover:text-gray-800 hover:font-medium w-full pr-2 flex justify-start transform transition duration-100 ease-in-out'
                onMouseEnter={() => image && setCurrentDetail(item)}>
                <Label
                  {...link?.label}
                  icon={link.label.icon ? { ...link.label.icon } : null}
                  weight={link.label.icon ? 'medium' : 'normal'}
                  truncate
                  size='lg'
                />
              </div>
            </Link>
          ),
        };
      });

      return (
        <nav
          className={`${returnNavigationItem(
            details.items.length
          )} flex justify-center py-8 pr-3`}
          aria-labelledby='solutions-heading'>
          <div className='w-full'>
            <List listItems={navigationDetailListItems} />
          </div>
        </nav>
      );
    });

  return (
    <div className='border-t w-full flex justify-center border-b'>
      <div className='flex flex-wrap max-w-7xl w-full px-10 relative mx-auto'>
        {returnNavigationDetailsList()}
        <div
          className={`${returnNavigationItem(
            details.items.length
          )} flex justify-start py-8`}>
          <SubCollectionHighlight
            color={color}
            detail={currentDetail}
          />
        </div>
      </div>
    </div>
  );
};
